var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { connect } from "@irati/store";
import { FormattedMessage } from "@irati/utils/lang";
import { StepWrapper, StepsRecap, Steps, ActiveBar, Step } from "./styled";
var StepIndicator = /** @class */ (function (_super) {
    __extends(StepIndicator, _super);
    function StepIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepIndicator.prototype.render = function () {
        var _a = this.props, currentStep = _a.currentStep, isMobile = _a.isMobile, stepsCount = _a.stepsCount, className = _a.className;
        var steps = [];
        for (var i = 1; i <= stepsCount; i++)
            steps.push(i);
        return (React.createElement(StepWrapper, { isMobile: isMobile, className: className },
            React.createElement(StepsRecap, null,
                React.createElement(FormattedMessage, { id: "platform.stepIndicator.stepsCounter", values: {
                        currentStep: (React.createElement("strong", null,
                            React.createElement(FormattedMessage, { id: "platform.stepIndicator.currentStep", values: { currentStep: currentStep } }))),
                        totalSteps: steps.length
                    } })),
            React.createElement(Steps, null,
                React.createElement(ActiveBar, { active: currentStep }),
                steps.map(function (step, i) { return (React.createElement(Step, { active: i + 1 <= currentStep, key: i }, step)); }))));
    };
    return StepIndicator;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ isMobile: mq.lessThan.sm });
};
export default connect(mapStateToProps)(StepIndicator);
